import { render } from "./ResellerNews.vue?vue&type=template&id=27313bd8&scoped=true"
import script from "./ResellerNews.vue?vue&type=script&lang=js"
export * from "./ResellerNews.vue?vue&type=script&lang=js"

import "./ResellerNews.vue?vue&type=style&index=0&id=27313bd8&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27313bd8"]])

export default __exports__